import type { SessionLaunch } from "./session-document.ts";

export const CONSENT_CLICK = "consent trail click";

export function consentClickLine(now: Date): string {
  return `${CONSENT_CLICK} ${now.toISOString()}`;
}

export function sessionCreateBody(request: SessionLaunch, reason: string | undefined): SessionLaunch & { reason?: string } {
  return reason === undefined ? request : { ...request, reason };
}
